export enum MeasurementSystem {
  Meters = 0,
  Feet,
  Inches,
  Centimeters,
  Millimeters,
  FeetUs,
}
